import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'rp-config-view',
  templateUrl: './rp-config-view.component.html',
  styleUrls: ['./rp-config-view.component.scss']
})
export class RpConfigViewComponent {}
